import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DrawersProvider } from "./hooks/useDrawers";
import { AuthProvider } from "./hooks/useAuth";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { FloatingCTAs } from "./components/FloatingCTAs";
import { FloatingChatWidget } from "./components/FloatingChatWidget";
import Index from "./pages/Index";
import Solutions from "./pages/Solutions";
import Catalog from "./pages/Catalog";
import FlowerDetail from "./pages/FlowerDetail";
import Farms from "./pages/Farms";
import Logistics from "./pages/Logistics";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import { Auth } from "./pages/Auth";
import OAuthConsent from "./pages/OAuthConsent";
import CMS from "./pages/CMS";
import { DrawersManager } from "./components/DrawersManager";
import { SEOHead } from "./components/SEOHead";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <BrowserRouter>
          <DrawersProvider>
            <Toaster />
            <Sonner />
            <div className="min-h-screen bg-background">
              <SEOHead />
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/auth" element={<Auth />} />
                  <Route path="/.lovable/oauth/consent" element={<OAuthConsent />} />
                  <Route path="/cms" element={<CMS />} />
                  <Route path="/solutions" element={<Solutions />} />
                  <Route path="/catalog" element={<Catalog />} />
                  <Route path="/catalog/flower/:id" element={<FlowerDetail />} />
                  <Route path="/farms" element={<Farms />} />
                  <Route path="/logistics" element={<Logistics />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/faq" element={<Contact />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
              <Footer />
              <FloatingCTAs />
              <FloatingChatWidget />
              <DrawersManager />
            </div>
          </DrawersProvider>
        </BrowserRouter>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
